document.addEventListener("DOMContentLoaded", function () {
    const mobilelanguageSelector = document.querySelector(".header-mobile .mobile-c-header-language-selector-wrapper");
    let mobilechevronDown = document.querySelector(".header-mobile .mobile-c-chevron-down-wrapper .c-chevron-down");
    const mobilelanguageDropdown = document.querySelector(".header-mobile .mobile-c-header-language-dropdown");
    const mobilelanguageLinks = document.querySelectorAll(".header-mobile .mobile-c-language-single");

    // Detect active language based on URL
    let mobilecurrentUrl = window.location.href;
    mobilelanguageLinks.forEach(link => {
        if (mobilecurrentUrl.includes("boostificpro.hu") && link.classList.contains("mobile-c-hu")) {
            link.classList.add("active");
        } else if (mobilecurrentUrl.includes("boostificpro.com") && link.classList.contains("mobile-c-en")) {
            link.classList.add("active");
        } else if (mobilecurrentUrl.includes("boostificpro.ro") && link.classList.contains("mobile-c-ro")) {
          link.classList.add("active");
        } else if (mobilecurrentUrl.includes("boostificpro.sk") && link.classList.contains("mobile-c-sk")) {
          link.classList.add("active");
        } else {
            link.classList.remove("active");
        }
    });
    
    const mobileactiveLanguage = document.querySelector('.header-mobile .mobile-c-language-single.active');
    let mobileplaceholder = document.querySelector('.header-mobile .mobile-c-header-language-placeholder');
    mobileplaceholder.innerHTML = mobileactiveLanguage.innerHTML;

    let newMobileChevronDown = mobilechevronDown.cloneNode(true);
    mobilechevronDown.parentNode.replaceChild(newMobileChevronDown, mobilechevronDown);
    mobilechevronDown = newMobileChevronDown;
    let newMobilePlaceholder = mobileplaceholder.cloneNode(true);
    mobileplaceholder.parentNode.replaceChild(newMobilePlaceholder, mobileplaceholder);
    mobileplaceholder = newMobilePlaceholder;

    
    // Toggle dropdown on click
    mobilechevronDown.addEventListener("click", function (event) {
      event.stopPropagation();
      mobilelanguageSelector.classList.toggle("active");
    });
    mobileplaceholder.addEventListener("click", function (event) {
        event.stopPropagation();
        mobilelanguageSelector.classList.toggle("active");
    });
    // Close dropdown if clicking outside
    document.addEventListener("click", function (event) {
        if (!mobilelanguageSelector.contains(event.target)) {
            mobilelanguageSelector.classList.remove("active");
        }
    });

    const languageSelector = document.querySelector(".header-basic .c-header-language-selector-wrapper");
    let chevronDown = document.querySelector(".header-basic .c-chevron-down");
    const languageDropdown = document.querySelector(".header-basic .c-header-language-dropdown");
    const languageLinks = document.querySelectorAll(".header-basic .c-language-single");

    // Detect active language based on URL
    let currentUrl = window.location.href;
    languageLinks.forEach(link => {
        if (currentUrl.includes("boostificpro.hu") && link.classList.contains("c-hu")) {
            link.classList.add("active");
        } else if (currentUrl.includes("boostificpro.com") && link.classList.contains("c-en")) {
            link.classList.add("active");
        } else if (currentUrl.includes("boostificpro.ro") && link.classList.contains("c-ro")) {
          link.classList.add("active");
        } else if (currentUrl.includes("boostificpro.sk") && link.classList.contains("c-sk")) {
          link.classList.add("active");
        } else {
            link.classList.remove("active");
        }
    });

    const activeLanguage = document.querySelector('.header-basic .c-language-single.active');
    let placeholder = document.querySelector('.header-basic .c-header-language-placeholder');
    placeholder.innerHTML = activeLanguage.innerHTML;

    let newChevronDown = chevronDown.cloneNode(true);
    chevronDown.parentNode.replaceChild(newChevronDown, chevronDown);
    chevronDown = newChevronDown;
    let newPlaceholder = placeholder.cloneNode(true);
    placeholder.parentNode.replaceChild(newPlaceholder, placeholder);
    placeholder = newPlaceholder;
    
    // Toggle dropdown on click
    chevronDown.addEventListener("click", function (event) {
        event.stopPropagation();
        languageSelector.classList.toggle("active");
    });
    placeholder.addEventListener("click", function (event) {
        event.stopPropagation();
        languageSelector.classList.toggle("active");
    });

    // Close dropdown if clicking outside
    document.addEventListener("click", function (event) {
        if (!languageSelector.contains(event.target)) {
            languageSelector.classList.remove("active");
        }
    });
  
});